<template>
    <v-dialog v-model="formdialog">
        <v-card>
            <v-container fluid>
                <v-row no-gutters>
                    <h1>Stock Book {{ com }}</h1>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="3">
                        <v-autocomplete
                            label="Product Name"
                            v-model="selectedproduct"
                            :items="productnames"
                            item-title="productnames_productname"
                            item-value="productnames_productname"
                            density="default"
                            placeholder="Product Name"
                            auto-select-first
                            item-props
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field label="Start Date" v-model="startdate" type='date' required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field label="End Date" v-model="enddate" type='date' required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-btn
                            depressed
                            color="primary"
                            type="submit"
                            @click=showData()
                        >
                            Show
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="headers"
                    :items="stockbook"
                ></v-data-table>
                <div v-if="showMessage">
                    <ShowError @closesnackbar="closesnackbar"/>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
import { useAuthStore } from '@/stores/AuthStore'
import ProductService from '@/services/ProductService'
import ShowError from '@/components/Showerror'

const props = defineProps(['showStockBook','selectedProduct','startDate', 'endDate', 'company'])
const emit = defineEmits(['closedialog'])

var formdialog = ref(props.showStockBook)

var productnames = ref([])
var stockbook = ref([])
var stockbookgmw = ref([])
var stockbooksm = ref([])

var selectedproduct = ref(props.selectedProduct)
var startdate = ref(props.startDate)
var enddate = ref(props.endDate)
var com = ref(props.company)

var headers = ref([
    {
        title: 'Date',
        align: 'start',
        sortable: true,
        key: 'date',
    },
    { title: 'Particular', key: 'particular' },
    { title: 'Purchase', key: 'purchase' },
    { title: 'Sale', key: 'sale' },
    { title: 'Stock', key: 'stock' }
])

var showMessage = ref(false)
var msgStatus = ref('primary')
var msg = ref('This is msg')

provide('msgStatus', msgStatus)
provide('msg', msg)
provide('showMessage', showMessage)

onBeforeMount(async () => {
    await getproducts()
    if(com.value =='GMW'){
        await getstockbookdatagmw()
    }else{
        await getstockbookdatasm()
    }
    
})

async function showData(){
    console.log("Company is "+com.value)
    if(com.value =='GMW'){
        await getstockbookdatagmw()
    }else{
        await getstockbookdatasm()
    }
}

async function getproducts(){
    try{
        var product = (await ProductService.getallnamesgmw()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    productnames.value = product
    return product
}

async function getstockbookdatagmw(){
    try{
        var stockdata = (await ProductService.getstockbookgmw(selectedproduct.value,startdate.value,enddate.value)).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    stockbook.value = stockdata
    return stockdata
}

async function getstockbookdatasm(){
    try{
        var stockdata = (await ProductService.getstockbooksm(selectedproduct.value,startdate.value,enddate.value)).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    stockbook.value = stockdata
    return stockdata
}

watch(formdialog, async(val)=>{
    if(formdialog.value===false){
        //console.log("Form is closed")
        emit('closedialog')
    }
})

</script>